import React, { useState } from "react";
import {
  Page,
  Card,
  Button,
  TextField,
  ResourceList,
  ResourceItem,
  Text,
} from "@shopify/polaris";
import { GetAIRecommendations } from "../../services/ai";

const Chatbot = () => {
  const [step, setStep] = useState(1);
  const [giftFor, setGiftFor] = useState("");
  const [hobbies, setHobbies] = useState("");
  const [loading, setLoading] = useState(false);
  const [recommendations, setRecommendations] = useState([]);

  const handleNext = () => {
    if (step === 1 && giftFor.trim()) {
      setStep(2);
    } else if (step === 2 && hobbies.trim()) {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setLoading(true);

    // Create a prompt
    const prompt = `Create a gift recommendation for ${giftFor}, who has hobbies like ${hobbies}.`;
    console.log(prompt);
    try {
      // Replace with your backend endpoint
      const { data } = await GetAIRecommendations(prompt);
      if (data.result) {
        console.log(data.result);
        setRecommendations(data.result);
      }
    } catch (error) {
      console.error("Error fetching recommendation:", error);
      //   setResponse("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const resetChatbot = () => {
    setStep(1);
    setGiftFor("");
    setHobbies("");
    setRecommendations([]);
    // setResponse("");
  };

  return (
    <Page title="Gift Recommendation Chatbot">
      <Card sectioned>
        <Button
          onClick={() => {
            resetChatbot();
          }}
        >
          Reset
        </Button>
        {recommendations.length ? (
          <ResourceList
            resourceName={{ singular: "product", plural: "products" }}
            items={recommendations}
            renderItem={(product) => {
              console.log(product);
              const { _id, title, description, variants } = product;
              return (
                <ResourceItem
                  id={_id}
                  accessibilityLabel={`View details for ${title}`}
                >
                  <Text variant="headingMd">{title}</Text>

                  <br />
                  <p>{description}</p>
                  <p>
                    <Text variant="bodyMdd">Price: {variants[0].price}</Text>
                  </p>
                </ResourceItem>
              );
            }}
          />
        ) : (
          <>
            {step === 1 && (
              <TextField
                label="Who is the gift for?"
                value={giftFor}
                onChange={(value) => setGiftFor(value)}
                autoComplete="off"
              />
            )}
            {step === 2 && (
              <TextField
                label="What are their hobbies?"
                value={hobbies}
                onChange={(value) => setHobbies(value)}
                autoComplete="off"
              />
            )}
            <br />
            <Button
              onClick={handleNext}
              primary
              loading={loading}
              disabled={
                (step === 1 && !giftFor.trim()) ||
                (step === 2 && !hobbies.trim())
              }
            >
              {step === 2 ? "Submit" : "Next"}
            </Button>
            {/* </InlineStack> */}
          </>
        )}
      </Card>
    </Page>
  );
};

export default Chatbot;
